module.exports = __webpack_public_path__ + "static/32-a764e253e5c4cc413fb5aa1ac9cfb182.png";